<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图">
    </div>
    <p class="title">深圳市亮任网络科技有限公司</p>
    <p class="address_tel_fax">
      <span>地址：深圳市龙岗区平湖街道鹅公岭社区凤凰大道9号K栋107</span>
      <span>Tel：100-0184401</span>
    </p>
    <p class="email_wx">
      <span>邮箱：jzwzpgc@outlook.com</span>
    </p>
    <p class="copy">Copyright &copy; 2026 - {{ new Date().getFullYear() }} 深圳市亮任网络科技有限公司<span style="margin-left: 20px; cursor: pointer;" @click="gots">ICP备案号：粤ICP备2026106502号</span></p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    gots() {
      window.open("https://beian.miit.gov.cn/");
    }
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue